import * as React from "react";
import { memo } from "react";
import get from "lodash/get";
import Typography from "@material-ui/core/Typography";
import { useRecordContext } from "ra-core";

const PhoneField = memo((props) => {
  const { className, source, emptyText, ...rest } = props;
  const record = useRecordContext(props);
  const value = get(record, source);

  return (
    <Typography
      component="span"
      variant="body2"
      className={className}
      {...rest}
    >
      {value != null && typeof value !== "string"
        ? JSON.stringify(value?.split("|")[0])
        : value?.split("|")[0] || emptyText}
    </Typography>
  );
});

export default PhoneField;
